/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListIamUserRolesRequest
 */
export interface ListIamUserRolesRequest {
    /**
     * 
     * @type {string}
     * @memberof ListIamUserRolesRequest
     */
    iamUserId?: string;
}

export function ListIamUserRolesRequestFromJSON(json: any): ListIamUserRolesRequest {
    return ListIamUserRolesRequestFromJSONTyped(json, false);
}

export function ListIamUserRolesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListIamUserRolesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamUserId': !exists(json, 'iam_user_id') ? undefined : json['iam_user_id'],
    };
}

export function ListIamUserRolesRequestToJSON(value?: ListIamUserRolesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_user_id': value.iamUserId,
    };
}


